(function() {
  'use strict';

    ResetTraineeCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('ResetTraineeCtrl', ResetTraineeCtrl);

    function ResetTraineeCtrl($scope, $timeout) {
      var mode = '';
      var confimationEvent = '';

      $scope.modal = {
        content: 0,
        data: {},
        deadlineMessage: '',
        status: ''
      };

      $scope.retakeCourse = function() {
        $scope.modal.status = 'saving';

        $scope.$emit(confimationEvent, $scope.modal.data, function() {
          $scope.dismiss();
          $timeout(function() {
            $scope.modal.status = ''
          }, 500);
        });
      };

      var handleBulkReset = function(event, numberOfTrainees, data) {
        if(numberOfTrainees === 0) return;
        mode = 'bulk';

        confimationEvent = {
          courseBulkResetRequested: 'courseBulkResetConfirmed',
          seriesBulkResetRequested: 'seriesBulkResetConfirmed'
        }[event.name];

        $scope.modal.content = numberOfTrainees;
        if (data){
          $scope.modal.data = data;
        }
      };

      $scope.$on('courseBulkResetRequested', handleBulkReset);
      $scope.$on('seriesBulkResetRequested', handleBulkReset);

      var handleSingleReset = function(event, trainee) {
        if(!trainee) return;
        mode = 'single';

        confimationEvent = {
          courseResetRequested: 'courseResetConfirmed',
          seriesResetRequested: 'seriesResetConfirmed',
          seriesCourseResetRequested: 'seriesCourseResetConfirmed'
        }[event.name];

        $scope.modal = {
          content: 1,
          data: trainee,
          deadlineMessage: '',
          status: '',
          mode: 'single'
        };

        if(event.name === 'seriesCourseResetRequested' && trainee.contentModifiedAfterCompletion)
          $scope.modal.deadlineMessage += 'Their series will be updated, requiring them to take any new courses.';

        if(event.name === 'seriesCourseResetRequested' && trainee.extensionDate)
          $scope.modal.deadlineMessage = 'Their deadline will be extended to ' + trainee.extensionDate + '.';

        $scope.show();
      };

      $scope.$on('courseResetRequested', handleSingleReset);
      $scope.$on('seriesResetRequested', handleSingleReset);
      $scope.$on('seriesCourseResetRequested', handleSingleReset);

    }
})();
